module.exports = __webpack_public_path__ + "static/media/heavyCould.5954b39e.ico";